import { combineReducers } from 'redux';
import App from '@iso/redux/app/reducer';
import Box from '@iso/redux/box/reducer';
import modal from '@iso/redux/modal/reducer';
import drawer from '@iso/redux/drawer/reducer';
import profile from '@iso/redux/profile/reducer';
import LanguageSwitcher from '@iso/redux/languageSwitcher/reducer';

export default combineReducers({
  Box,
  App,
  modal,
  drawer,
  profile,
  LanguageSwitcher,
});
